import { Box } from "@mui/material";
import { useState } from "react";
import { debug_log } from "../utils/debugLog";

export const EventToMessage = ({
  eventParser,
  messageProcessor,
  bufferLimit = 10,
  callback = () => null,
  event = "onClick",
  className,
  ...props
}) => {
  const [message, setMessage] = useState("");

  const handleEvent = (e) => {
    const parsed = eventParser(e);
    if (typeof parsed === "undefined") {
      return;
    }

    const newMessage = (message + parsed).slice(-bufferLimit);

    debug_log(`EventToMessage: ${newMessage}`);

    setMessage(messageProcessor(newMessage, callback));
  };

  className = [className, "EventToMessage"].filter((v) => v).join(" ");

  return <Box className={className} {...{ [event]: handleEvent }} {...props} />;
};
